var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.363636 13.5L8.06818 0.40909L15.7727 13.5H0.363636ZM8.06818 12.0341C8.35985 12.0341 8.60795 11.9318 8.8125 11.7273C9.02083 11.5189 9.125 11.2689 9.125 10.9773C9.125 10.6856 9.02083 10.4375 8.8125 10.233C8.60795 10.0246 8.35985 9.92045 8.06818 9.92045C7.77652 9.92045 7.52652 10.0246 7.31818 10.233C7.11364 10.4375 7.01136 10.6856 7.01136 10.9773C7.01136 11.2689 7.11364 11.5189 7.31818 11.7273C7.52652 11.9318 7.77652 12.0341 8.06818 12.0341ZM7.375 8.63636H8.76136L8.86364 4.77273H7.27273L7.375 8.63636Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlackIcon);
export default __webpack_public_path__ + "static/media/WarningBlackIcon.95a0420fa136056a5f861f8845ead2c1.svg";
export { ForwardRef as ReactComponent };